// extracted by mini-css-extract-plugin
export default {"mn-sample-modal":"index_mn-sample-modal__c2TD0"};